module.exports = __webpack_public_path__ + "static/media/WF.cddd6311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/WF.svg
// module id = 2291
// module chunks = 7